
jQuery(document).ready(function(){
      jQuery(".measurement-tab").click(function(){
        jQuery(this).addClass('show').siblings().removeClass('show');
        var sizeid = jQuery(this).attr('data-id');
        jQuery('.size-chart').removeClass('active');
        jQuery(sizeid).addClass('active');
      });
      
      jQuery(".size-guide__tables li").click(function(){
        jQuery(this).addClass('active').siblings().removeClass('active');
        var clas = jQuery(this).attr('data-class');
        jQuery('.size-guide-content').hide();
        jQuery(clas).show();
      });
      
      jQuery(".accordion-title").click(function(){
        if(jQuery(this).hasClass('active')) {
        	jQuery(this).removeClass('active').next().hide();
        }
        else {
        var image_src = jQuery(this).attr('data-measurement-image');
        jQuery('.measuring-img-women').attr("src", image_src);
        jQuery(this).parents('ul').find('.accordion-content').hide()
        jQuery(this).addClass('active').parent().siblings().find('.accordion-title').removeClass('active');
        jQuery(this).next().show();
        jQuery('#measurement_label').val(jQuery(this).attr('data-measurement-label'));
          sizeUpdate(); }
      });
      
      
      jQuery(".size-options__list li").click(function(){
        var va = jQuery(this).attr('data-size');
        jQuery('.size-options__selected').text(va);
        jQuery('#size_options').val(va);
      	jQuery(this).parent().slideUp();
        sizeUpdate();
      });
      
      jQuery('.unit-options input').click(function(){
        jQuery('#size_value').val(jQuery(this).val());
        sizeUpdate();
      });
      
    });
  
function sizeUpdate() {
        const person = { size4:{bust:{in: 30, cm:76.2}, waist:{in: 22, cm:55.88}, hips:{in: 32, cm:81.28}}, size6:{bust:{in: 32, cm:81.26}, waist:{in: 24, cm:80.96}, hips:{in: 34, cm:86.36}}, size8:{bust:{in: 34, cm:86.3}, waist:{in: 26, cm:66.4}, hips:{in: 36, cm:91.44}}, size10:{bust:{in: 36, cm:91.44}, waist:{in: 28, cm:71.12}, hips:{in: 38, cm:96.52}}, size12:{bust:{in: 38, cm:96.52}, waist:{in: 30, cm:76.2}, hips:{in: 40, cm:101.6}}, size14:{bust:{in: 40, cm:101.6}, waist:{in: 32, cm:81.28}, hips:{in: 42, cm:106.68}}};
      
        var st0 = 'size'+document.getElementById("size_options").value;
        var st1 = document.getElementById("measurement_label").value;
        var st2 = document.getElementById('size_value').value;
        document.getElementById("sizvalue").innerHTML = st1 + ' ' + person[st0][st1][st2] + ' ' + st2;
      }